import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AzureApiInterceptor } from './shared/services/http/azure-api.interceptor';
import { HttpErrorInterceptor } from './shared/services/http/http-error.interceptor';
import { provideToastr } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes), 
    provideAnimationsAsync(),    
    provideHttpClient(withInterceptorsFromDi()),
    // preventDuplicates: parallel calls on a page failing with the same message
    // (e.g. PO Details firing several component lookups) stacked one toast each.
    provideToastr({ preventDuplicates: true, countDuplicates: true }),
    provideAnimations(),
    {provide: HTTP_INTERCEPTORS, useClass: AzureApiInterceptor, multi: true},
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    DatePipe,
  ]
};
